import type {CarouselImage} from '../components/ImageCarousel'
import {createPostQuery} from '../hooks/useQuery'
import type {DollarAmount} from './currency-map'


type Feature = {
    id: number
    name: string
}

export type AvailableVehicle = {
    id:  number
    capacity:  number
    name: string
    code: string
    features: Feature[]
    images: CarouselImage[],
    unavailable: boolean
    hourlyRate: DollarAmount | null
}

type VehicleSegment = {
    /** ISO datetime for pickup e.g. "2023-01-17T22:35:00.000Z" */
    pickupTimeIso: string
    duration: string
}

type AvailableVehiclesRequest = {
    segments: VehicleSegment[]
    bookingId?: StringNum
    companyId?: StringNum
    capacity?: StringNum
    companyCode?: string
    tripType: string|nil
}

type AvailableVehiclesResponse = {
    vehicles: AvailableVehicle[]
}

export const useAvailableVehicles = createPostQuery<AvailableVehiclesRequest,AvailableVehiclesResponse>('company.availableVehicles')
